/**
* @description: 门店管理-门店列表
* @author: ccy
* @update: ccy (2017-3-27 10:00)
* @update: hwx
* @update: lyr
* @update: wgt
* @update: chy
*/
<template>
    <div>
        <div class="store" v-show="!add && !isMap && !roomList">
            <div class="row">
                <div class="col-md-2 col-sm-3">
                    <button class="btn btn-flat btn-large btn-border-orange btn-orange addstore" type="button"
                        @click="addstore">添加门店</button>
                </div>
                <div class="col-md-2 col-sm-3">
                    <button type="button" class="btn btn-flat btn-large btn-orange"><a
                            href="https://vodonline.g-hi.com/uploads/importxls/巨嗨包厢导入模板.xlsx">包厢导入模板下载</a></button>
                </div>
                <div class="col-md-2 col-sm-3">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="addXlsFun">导入</button>
                    <input type="file" @change="uploadXls($event)" id="xlsFile" ref="xlsFile">
                </div>
            </div>
            <div class="row filter">
                <label class="storename control-label pull-left">门店名称：</label>
                <div class="col-md-2 ct-col">
                    <!-- <select class="form-control" ref="selectstore" data-placeholder="请选择门店"></select> --> 
                    <el-select  ref="selectstore" v-model="shop_id" filterable clearable placeholder="请选择">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.text" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-md-1 col-sm-2 pull-right">
                    <button class="btn filterbtn btn-flat btn-small btn-border-orange btn-orange" type="button"
                        @click="queryStore">查询</button>
                </div>
            </div>
            <table class="table table-bordered table-hover" data-pagination="true" ref="storelist"></table>
        </div>
        <div v-show="add && !isMap && !roomList" style="width: 90%">
            <div class="addStore">
                <div class="row addTitle">基本信息</div>
                <div class="storeContent">
                    <div class="row impression">
                        <label class="impressiontitle">门店印象</label>
                        <img @click="uploadImg" class="upload" v-bind:src="storeImg">
                        <input id="uploadPackage" class="uploadinput" name="file" type="file" style="display: none"
                            v-on:change="changeUpload($event)" ref="uploadPackage">
                    </div>
                    <div class="row line" v-show="detail">
                        <div class="col-md-6 col-sm-6">
                            <label class="formname pull-left">所属商家</label>
                            <div class="col-md-9 col-sm-9">
                                <input type="text" class="form-control store-name" placeholder="请输入门店名称">
                            </div>
                        </div>
                    </div>
                    <div class="row line ">
                        <div class="col-md-6 col-sm-6">
                            <label class="formname pull-left">门店名称</label>
                            <div class="col-md-8 col-sm-8">
                                <input type="text" class="form-control store-phone" placeholder="请输入门店名称"
                                    v-model="storeName">
                            </div>
                        </div>
                    </div>
                    <div class="row line">
                        <div class="col-md-6 col-sm-6">
                            <label class="formname pull-left">联系电话</label>
                            <div class="col-md-8 col-sm-8">
                                <input type="text" class="form-control" placeholder="请输入门店联系电话" v-model="telephone">
                            </div>
                        </div>
                    </div>
                    <div class="row line">
                        <div class="col-md-6 col-sm-6">
                            <label class="formname pull-left">门店地址</label>
                            <div class="col-md-4" style="width: 35%;margin-right: -18px">
                                <select class="select2 form-control store-province" style="width: 100%;"
                                    data-placeholder="选择省份">
                                    <option value=""></option>
                                </select>
                            </div>
                            <div class="col-md-4" style="width: 35%;">
                                <select class="form-control store-city" style="width: 100%;" data-placeholder="选择城市">
                                    <option value=""></option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row line">
                        <div class="col-md-6 col-sm-6">
                            <label class="formname pull-left">详细地址</label>
                            <div class="col-md-8 col-sm-8" style="position: relative" @click="location">
                                <input type="text" class="form-control address-detail" placeholder="请输入门店地址"
                                    v-model="addressDetail">
                                <img src="../../assets/images/address.png"
                                    style="position: absolute;height: 28px;width: 24px;right: 20px;top: 2px;padding: 5px;">
                            </div>
                        </div>
                    </div>
                    <div class="row line">
                        <div class="col-md-6 col-sm-6">
                            <label class="formname pull-left">营业时间</label>
                            <div class="col-md-8 col-sm-8" @click="chooseTime">
                                <input type="text" class="form-control store-time" placeholder="请选择营业时间"
                                    v-model="businessTime" style="cursor: pointer;background-color: #ffffff" readonly>
                            </div>
                        </div>
                    </div>
                    <div class="row line" v-show="detail">
                        <div class="col-md-6 col-sm-6">
                            <label class="formname pull-left">包厢数量</label>
                            <div class="col-md-8 col-sm-8">
                                <input type="text" class="form-control" placeholder="包厢数量10个" v-model="room_count"
                                    readonly style="background-color: #ffffff">
                            </div>
                        </div>
                    </div>
                    <div class="row line" v-show="detail">
                        <div class="col-md-6 col-sm-6">
                            <label class="formname pull-left">初始化商品数据</label>
                            <div class="col-md-8 col-sm-8">
                                <select class="form-control" id="dataresource">
                                    <option value=""></option>
                                    <option>前沿商品默认商品库1</option>
                                    <option>前沿商品默认商品库2</option>
                                    <option>前沿商品默认商品库3</option>
                                    <option>前沿商品默认商品库4</option>
                                    <option>前沿商品默认商品库5</option>
                                    <option>前沿商品默认商品库6</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-left: 50px">
                    <button class="btn btn-middle btn-border-gray btn-flat addbtn" @click="returnList">返回</button>
                    <button class="btn btn-middle btn-orange btn-border-orange  btn-flat addbtn sure" @click="saveStore"
                        v-show="!edit">保存</button>
                    <button class="btn btn-middle btn-orange btn-border-orange  btn-flat addbtn sure"
                        @click="updateStore" v-show="edit">保存</button>
                </div>
            </div>
            <div class="shade" v-show="popup"></div>
            <div class="popup" v-show="popup">
                <div class="popclose" @click="closePop"></div>
                <div class="poptitle">使用时间选择</div>
                <div class="timeContent">
                    <div class="starttime">开始时间：</div>
                    <select class="time starthour"></select>
                    <label class="colon">:</label>
                    <select class="time startseconds"></select>
                    <div class="starttime">结束时间：</div>
                    <select class="time stophour"></select>
                    <label class="colon">:</label>
                    <select class="time stopseconds"></select>
                    <div class="popbottom">
                        <button class="btn btn-flat btn-middle btn-border-orange btn-orange popbtn"
                            @click="setTime">确定</button>
                        <button class="btn btn-flat btn-middle btn-border-gray pull-right popbtn"
                            @click="closePop">取消</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="store-location mapStyle" style="width:90%;" v-show="isMap && !roomList">
            <div class="row" style="margin-bottom: 15px">
                <div class="col-md-3">
                    <label class="col-md-3 control-label detalilabel">门店名称:</label>
                    <input class="col-md-7 store-name detailspan" v-model="storeName" readonly />
                </div>
                <div class="col-md-6">
                    <label class="col-md-3 control-label detalilabel">区域:</label>
                    <span class="col-md-7 store-area-location detailspan"></span>
                </div>
            </div>
            <div class="row col-md-5" style="margin-bottom: 20px">
                <label class="col-md-3 control-label detalilabel">详细地址:</label>
                <div class="col-md-9">
                    <input type="text" class="form-control store-detail-addr " placeholder="请输入详细地址（如：XX区XX街道XX号）">
                </div>
            </div>
            <div class="row mymap">
                <div class="store-map" id="store-map">

                </div>
            </div>
            <div class="row" style="margin-left: 350px;margin-top: 50px">
                <button class="btn btn-middle btn-border-gray btn-flat mapbtn" @click="mapReturn">返回</button>
                <button class="btn btn-middle btn-orange btn-border-orange  btn-flat mapbtn" style="margin-left: 50px"
                    @click="saveMap">确定</button>
            </div>
        </div>
        <div v-show="detail" style="display: none"></div>
        <div v-show="roomList" class="room-list-container">
            <div class="room-list-header">
                <h2 class="room-list-title">包厢列表</h2>
                <div class="store-info">门店: {{ currentStoreName }}</div>
            </div>

            <div class="room-filter-section">
                <div class="filter-row">
                    <div class="filter-item">
                        <label class="filter-label">包厢号：</label>
                        <input type="text" class="form-control room-number-input" placeholder="请输入包厢号"
                            v-model="roomNumber">
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">包厢区域：</label>
                        <select class="form-control room-area-select" ref="roomArea" data-placeholder="全部"></select>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">包厢类型：</label>
                        <select class="form-control room-type-select" ref="roomType" data-placeholder="全部"></select>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">运营场景：</label>
                        <select class="form-control room-scene-select" ref="roomScene" data-placeholder="全部"></select>
                    </div>
                    <div class="filter-actions">
                        <button class="btn btn-primary query-btn" @click="handleQueryRoomList">查询</button>
                        <button class="btn btn-primary export-btn" @click="exportRoomList">导出</button>
                    </div>
                </div>
            </div>

            <el-table :data="roomListData" style="width: 100%">
                <el-table-column prop="id" label="包厢序号" />
                <el-table-column prop="name" label="包厢号" />
                <el-table-column prop="family_server_id" label="mac地址" />
                <el-table-column prop="room_area_name" label="包厢区域" />
                <el-table-column prop="room_type_name" label="包厢类型" />
                <el-table-column prop="operational_scene_name" label="运营场景" />
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="qrCode(scope.row)">自助开房二维码</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="room-pagination pull-right" v-if="roomTotal > 0">
                <el-pagination @size-change="handleRoomSizeChange" @current-change="handleRoomCurrentChange"
                    :current-page="roomCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="roomPageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="roomTotal">
                </el-pagination>
            </div>


            <el-button @click="returnToStoreList">返回</el-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'store_list',
    data() {
        return {
            msg: 'store_list',
            add: false,
            isMap: false,
            edit: false,
            detail: false,
            paramsdatas: null,
            queryInfo: null,
            popup: false,
            useTime: false,
            businessTime: null,
            resource: null,
            telephone: null,
            addressDetail: null,
            room_count: null,
            storeName: null,
            storeImg: null,
            province: [],
            cityList: [],
            mapDetail: null,
            selectProvince: null,
            selectCity: null,
            map: null,
            marker: null,
            markerLayer: null, // 腾讯地图标记图层
            geocoder: null, // 腾讯地图地理编码服务（用于地址搜索和坐标转地址）
            latitude: null,
            longitude: null,
            store_province: null,
            store_city: null,
            store_provinceId: null,
            store_cityId: null,
            id: null,
            shopList: [],
            current: false,
            change: null,
            room_type: [], //包厢类型
            room_area: [], //包厢区域
            room_scene: [], //包厢场景
            roomList: false, //是否显示包厢列表
            currentStoreName: '', //当前门店名称
            currentStoreId: '', //当前门店ID
            roomNumber: '', //包厢号
            roomListData: [], //包厢列表数据
            // 分页相关数据
            roomCurrentPage: 1, //当前页码
            roomPageSize: 10, //每页显示数量
            roomTotal: 0, //总记录数
            searchTimer: null ,// 地址搜索防抖定时器
            shop_id:"",//门店id
            shop_list:[],//门店列表数据
        }
    },
    computed: {
        // 腾讯地图key
        tx_ak() {
            return this.$store.state.tx_ak
        },
    },
    mounted() {
        this.getMerchantList();
        this.selectTime();
        $("#type").select2({
            placeholder: "对公账户",
            language: "zh-CN"
        });
        $("#bank").select2({
            placeholder: "请选择银行",
            language: "zh-CN"
        });
        $("#dataresource").select2({
            placeholder: "请选择商品的初始化数据来源",
            language: "zh-CN"
        });

        this.loadTencentMap();
    },
    beforeDestroy() {
        // 销毁地图实例，释放内存
        if (this.map) {
            this.map.destroy();
            this.map = null;
        }
        if (this.markerLayer) {
            this.markerLayer.setMap(null);
            this.markerLayer = null;
        }
    },
    methods: {
        loadTencentMap() {
            return new Promise((resolve, reject) => {
                // 检查是否已经加载
                if (window.TMap) {
                    console.log('✅ 腾讯地图已加载');
                    resolve(window.TMap);
                    return;
                }

                console.log('🔄 开始加载腾讯地图SDK...');
                console.log('使用Key:', this.tx_ak);

                const script = document.createElement('script');
                // 关键：必须添加 &libraries=service 才能使用搜索、地理编码等服务
                script.src = 'https://map.qq.com/api/gljs?v=1.exp&key=' + this.tx_ak + '&libraries=service';

                script.onload = () => {
                    if (window.TMap) {
                        console.log('✅ 腾讯地图SDK加载成功！');

                        // 验证服务是否可用
                        const checks = {
                            'TMap对象': !!window.TMap,
                            'Map类': !!window.TMap?.Map,
                            'LatLng类': !!window.TMap?.LatLng,
                            'MultiMarker类': !!window.TMap?.MultiMarker,
                            'service模块': !!window.TMap?.service,
                            'Search服务': !!window.TMap?.service?.Search,
                            'Geocoder服务': !!window.TMap?.service?.Geocoder,
                            'IPLocation服务': !!window.TMap?.service?.IPLocation
                        };

                        console.table(checks);

                        // 检查是否有失败项
                        const allPassed = Object.values(checks).every(v => v === true);
                        if (!allPassed) {
                            console.warn('⚠️ 部分地图服务不可用');
                        }

                        resolve(window.TMap);
                    } else {
                        console.error('❌ 脚本加载了但TMap对象不存在');
                        reject(new Error('TMap对象未定义'));
                    }
                };

                script.onerror = (error) => {
                    console.error('❌ 腾讯地图SDK加载失败:', error);
                    reject(new Error('地图脚本加载失败，请检查网络或Key是否正确'));
                };

                document.head.appendChild(script);
            });
        },

        //点击添加门店
        addstore: function () {
            let _this = this;
            _this.add = true;
            _this.edit = false;
            _this.storeName = null;
            _this.telephone = null;
            _this.addressDetail = null;
            _this.businessTime = null;
            _this.storeImg = null;
            _this.longitude = null;  // 清空经纬度
            _this.latitude = null;
            _this.getProvince(0, 0);
            // 不在这里调用 currentPosition()，应该在用户点击地址输入框时才定位
        },
        //初始化表格
        initTable: function () {
            let _this = this;
            let actionEvents = {
                'click .edit': function (e, value, row, index) {
                    _this.add = true;
                    _this.edit = true;
                    _this.getDetail(row);
                },
                'click .box-list': function (e, value, row, index) {
                    // 显示包厢列表
                    _this.roomList = true;
                    _this.currentStoreName = row.name;
                    _this.currentStoreId = row.id;
                    _this.getRoomConfig(row.id);
                    // 查询包厢列表
                    _this.queryRoomList();
                },
                'click .detail': function (e, value, row, index) {

                },
            };
            //$(this.$refs.storelist).bootstrapTable('destroy');
            $(this.$refs.storelist).bootstrapTable({
                pageSize: 10,
                pageList: [],
                sortName: 'status',
                ajax: function (params) {
                    _this.paramsdatas = params;
                    _this.getStoreList(params);
                },
                sidePagination: "server",
                pagination: true,
                columns: [{
                    field: "name",
                    title: "门店名称",
                    width: "15%"
                }, {
                    field: "room_count",
                    title: "包厢数",
                    width: "10%"
                }, {
                    field: "address",
                    title: "门店地址",
                    width: "20%"
                }, {
                    field: "manager_mobile",
                    title: "电话",
                    width: "10%"
                }, {
                    field: "business_time",
                    title: "营业时间",
                    width: "20%",
                    formatter: _this.setBusinessTime
                }, {
                    title: "操作",
                    width: "15%",
                    events: actionEvents,
                    formatter: _this.actionFormatter
                }]
            })
        },
        // 表格操作
        actionFormatter: function (value, row, index) {
            return [
                '<div class="orange-text">',
                '<a class="edit">修改</a>',
                '<a class="box-list">包厢列表</a>'
                // '<a class="detail">&nbsp;&nbsp;&nbsp;&nbsp;详情</a></div>'
            ].join('');
        },
        // 初始化营业时间
        setBusinessTime: function (value, row, index) {
            return row.open_hour + " - " + row.close_hour;
        },
        // 获取门店名称
        getMerchantList: function () {
            let _this = this;

            let shopDatas = [];
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                },
                "comment": []
            };
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        $.each(data.response.result, function (k, v) {
                            shopDatas.push({ id: v.id, text: v.name });
                        });
                        _this.shop_list = shopDatas;
                        // $(_this.$refs.selectstore).select2({
                        //     data: shopDatas,
                        //     allowClear: true,
                        //     minimumResultsForSearch: -1,
                        //     language: "zh-CN"
                        // });
                        _this.initTable();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },
        // 获取门店列表
        getStoreList: function (params) {
            let _this = this;
            let pageNumber = 1;
            if (params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": "10",
                        // "shop_id": $(_this.$refs.selectstore).val()
                        'shop_id': _this.shop_id
                    }
                },
                "comment": []
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/ShopList",
                data: {
                    json: datas2
                },
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.total,
                            rows: data.response.result
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: []
                        });
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },
        // 点击查询
        queryStore: function () {
            let _this = this;
            // let queryInfo = $(_this.$refs.selectstore).val();
           let queryInfo =  _this.shop_id
            if (queryInfo != '') {
                $(_this.$refs.storelist).bootstrapTable('refreshOptions', { pageNumber: 1 });
                //_this.initTable();
            } else {
                $(_this.$refs.storelist).bootstrapTable('refreshOptions', { pageNumber: 1 });
                //_this.initTable();
            }
        },
        //选择营业时间
        selectTime: function () {
            let seconds = [];
            for (let i = 0; i < 60; i++) {
                let item = {};
                item.id = i;
                item.text = (i < 10) ? '0' + i : i;
                seconds[i] = item;
            }
            let hour = [];
            for (let i = 0; i < 24; i++) {
                let item = {};
                item.id = i;
                item.text = (i < 10) ? '0' + i : i;
                hour[i] = item;
            }
            $(".starthour").select2({
                data: hour,
                language: "zh-CN"
            });
            $(".startseconds").select2({
                data: seconds,
                language: "zh-CN"
            });
            $(".stophour").select2({
                data: hour,
                language: "zh-CN"
            });
            $(".stopseconds").select2({
                data: seconds,
                language: "zh-CN"
            })
        },
        //关闭弹窗
        closePop: function () {
            this.popup = false;
        },
        //选择营业时间
        chooseTime: function () {
            this.popup = true;
        },
        // 选择初始化数据来源
        setDataResource: function () {
            let _this = this;

        },
        // 设置营业时间
        setTime: function () {
            let _this = this;
            _this.useTime = false;
            _this.popup = false;
            let starthour = $(".starthour").select2("val");
            let Starthour = (starthour < 10) ? '0' + starthour : starthour;
            let startseconds = $(".startseconds").select2("val");
            let Startseconds = (startseconds < 10) ? '0' + startseconds : startseconds;
            let stophour = $(".stophour").select2("val");
            let Stophour = (stophour < 10) ? '0' + stophour : stophour;
            let stopseconds = $(".stopseconds").select2("val");
            let Stopseconds = (stopseconds < 10) ? '0' + stopseconds : stopseconds;
            _this.businessTime = Starthour + ':' + Startseconds + ' -- ' + Stophour + ':' + Stopseconds;
        },
        //点击取消
        cancel: function () {
            this.popup = false;
        },
        //上传图片
        uploadImg: function () {
            $(".impression #uploadPackage").click();
        },
        changeUpload: function (e) {
            var _this = this;
            var layIndex = layer.load(0, {
                shade: [0.1, '#ececec']
            });
            var file = e.target.files[0];
            // 清除file
            e.target.value = '';
            if (typeof (file) == 'undefined') {
                layer.msg('图片上传失败');
                layer.close(layIndex);
                return false;
            }
            // 压缩图片
            var reader = new FileReader(),
                img = new Image();
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                img.src = e.target.result;
            };
            img.onload = function () {
                // 图片原始尺寸
                var originWidth = this.width;
                var originHeight = this.height;
                // 最大尺寸限制
                var maxWidth = 500, maxHeight = 240;
                // 目标尺寸
                var targetWidth = originWidth, targetHeight = originHeight;
                // 图片尺寸超过限制
                if (originWidth > maxWidth || originHeight > maxHeight) {
                    if (originWidth / originHeight > maxWidth / maxHeight) {
                        // 更宽，按照宽度限定尺寸
                        targetWidth = maxWidth;
                        targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                    } else {
                        targetHeight = maxHeight;
                        targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                    }
                }
                // canvas对图片进行缩放
                canvas.width = targetWidth;
                canvas.height = targetHeight;
                // 清除画布
                context.clearRect(0, 0, targetWidth, targetHeight);
                // 图片压缩
                context.drawImage(img, 0, 0, targetWidth, targetHeight);
                // canvas转为blob并上传
                var dataurl = canvas.toDataURL('image/png');
                var blob = dataURLtoBlob(dataurl);
                // 创建forme
                var form = new FormData();
                form.append('img', blob, "image.png");
                form.append("upload_path", "ktv_test");
                // 上传
                $.ajax({
                    type: "post",
                    dataType: "json",
                    processData: false,
                    contentType: false,
                    url: Vue.ctUrl + "Upload/api_uploadPic",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: form,
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            _this.storeImg = data.response.resault.img_url;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg("图片上传失败");
                        }
                        layer.close(layIndex);
                    },
                    error: function (err) {
                        layer.msg("网络原因");
                        layer.close(layIndex);
                    }
                });
            }
        },
        //添加门店点击保存
        saveStore: function () {
            let _this = this;
            if (_this.check()) {
                let times = _this.businessTime;
                let time = times.split("--");
                //                let provinceid =  $(".store-province").select2("data")[0].id;
                //                let province =  $(".store-province").select2("data")[0].text;
                //                let cityid =  $(".store-city").select2("data")[0].id;
                //                let city =  $(".store-city").select2("data")[0].text;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "version": Vue.version,
                            "name": _this.storeName,
                            "address": _this.addressDetail,
                            "manage_mobile": _this.telephone,
                            "address_longitude": _this.longitude,
                            "address_latitude": _this.latitude,
                            "city": _this.store_city,
                            "city_id": _this.store_cityId,
                            "province": _this.store_province,
                            "province_id": _this.store_provinceId,
                            "open_hour": time[0],
                            "close_hour": time[1],
                            "logo_url": _this.storeImg
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/ShopAdd",
                    data: {
                        json: datas2
                    },
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.msg("添加成功", {
                                time: 1200
                            });
                            $(_this.$refs.storelist).bootstrapTable('refreshOptions', { pageNumber: 1 });
                            _this.add = false;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            }
        },
        //获取省信息
        getProvince: function (provinceId, cityId) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version
                },
                "comment": []
            };
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getLinkage",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let result = data.response.result;
                        result.shift();
                        _this.mapDetail = result;
                        for (let i = 0; i < result.length; i++) {
                            let item = {};
                            item.id = result[i].id;
                            item.text = result[i].value;
                            _this.province[i] = item;
                        }
                        $(".store-province").select2({
                            data: _this.province,
                            language: "zh-CN"
                        });

                        if (provinceId == 0) {
                            $(".store-province").val("null").trigger("change");
                            $(".store-city").html("");
                            $(".store-city").select2({
                                data: [],
                                language: "zh-CN"
                            });
                            $(".store-city").prop('disabled', true);
                        } else {
                            $(".store-province").val(provinceId).trigger("change");
                            let res = $(".store-province").select2("data")[0];
                            let id = res.id;
                            _this.getCity(id);
                            $(".store-city").val(cityId).trigger("change");
                        }
                        $(".store-province").on("select2:select", function (e) {
                            let res = $(".store-province").select2("data")[0];
                            let id = res.id;
                            _this.getCity(id);
                            _this.store_province = res.text;
                            _this.store_provinceId = res.id;

                            // 清除旧的经纬度和change标记，让地图重新定位
                            _this.change = null;
                            _this.latitude = null;
                            _this.longitude = null;
                            _this.addressDetail = null;
                            console.log('🔄 省份已改变，已清除旧的地址和坐标');
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },
        //获取城市信息
        getCity: function (id) {
            let _this = this;
            for (let i = 0; i < _this.mapDetail[id - 2].child.length; i++) {
                let item = {};
                item.id = _this.mapDetail[id - 2].child[i].id;
                item.text = _this.mapDetail[id - 2].child[i].value;
                _this.cityList[i] = item;
            }
            $(".store-city").html("");
            $(".store-city").select2({
                data: _this.cityList,
                language: "zh-CN"
            });
            $(".store-city").prop('disabled', false);
            $(".store-city").on("select2:select", function (e) {
                let res = $(".store-city").select2("data")[0];
                _this.store_city = res.text;
                _this.store_cityId = res.id;

                // 清除旧的经纬度和change标记，让地图重新定位
                _this.change = null;
                _this.latitude = null;
                _this.longitude = null;
                _this.addressDetail = null;
                console.log('🔄 城市已改变，已清除旧的地址和坐标');
            });
        },
        //点击返回
        returnList: function () {
            $(this.$refs.storelist).bootstrapTable('refresh');
            this.add = false;
        },
        //获取门店详情
        getDetail: function (row) {
            let _this = this;
            _this.storeName = row.name;
            _this.telephone = row.manager_mobile;
            _this.addressDetail = row.address;
            _this.businessTime = row.open_hour + ' -- ' + row.close_hour;
            _this.storeImg = row.logo_url;
            _this.id = row.id;
            _this.getProvince(row.province_id, row.city_id);

            // 验证并设置经纬度（防止无效值）
            if (row.address_latitude && row.address_longitude &&
                parseFloat(row.address_latitude) !== 0 && parseFloat(row.address_longitude) !== 0) {
                _this.latitude = row.address_latitude;
                _this.longitude = row.address_longitude;
            } else {
                // 如果经纬度无效，清空让用户重新选择
                _this.latitude = null;
                _this.longitude = null;
                console.warn('⚠️ 门店经纬度无效，需要重新选择地址');
            }

            _this.change = row.city_id;

            // 不要在这里初始化地图！
            // 地图应该在用户点击"详细地址"输入框时才初始化（通过location方法）
            // 移除这行避免"far <= 0"错误
            // _this.initMap();

            $(".store-area-location").text(row.province + ' -- ' + row.city);
        },
        //门店修改
        updateStore: function () {
            let _this = this;
            if (_this.check()) {
                let times = _this.businessTime;
                let time = times.split("--");
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "version": Vue.version,
                            "id": _this.id,
                            "name": _this.storeName,
                            "address": _this.addressDetail,
                            "manage_mobile": _this.telephone,
                            "address_longitude": _this.longitude,
                            "address_latitude": _this.latitude,
                            "city": _this.store_city,
                            "city_id": _this.store_cityId,
                            "province": _this.store_province,
                            "province_id": _this.store_provinceId,
                            "open_hour": time[0],
                            "close_hour": time[1],
                            "logo_url": _this.storeImg
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/ShopUpd",
                    data: {
                        json: datas2
                    },
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.msg("修改成功");
                            $(_this.$refs.storelist).bootstrapTable('destroy');
                            _this.initTable();
                            _this.add = false;
                            //_this.initTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);

                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            }
        },
        //定位
        location: function () {
            let _this = this;

            // 调试日志：查看当前状态
            console.log('📍 打开地图:', {
                '编辑模式': _this.edit,
                '当前经度': _this.longitude,
                '当前纬度': _this.latitude,
                '详细地址': _this.addressDetail
            });

            _this.isMap = true;
            _this.add = false;

            // 等待DOM渲染完成后再初始化地图（关键！）
            _this.$nextTick(() => {
                _this.initMapLogic();
            });
        },

        // 地图初始化逻辑（从location方法中提取出来）
        initMapLogic: function () {
            let _this = this;

            console.log('🗺️ DOM已准备好，开始初始化地图...');

            // 检查地图容器是否存在
            let mapContainer = document.getElementById('store-map');
            if (!mapContainer) {
                console.error('❌ 地图容器不存在！');
                return;
            }
            console.log('✅ 地图容器存在，高度:', mapContainer.offsetHeight);

            let province = $(".store-province").select2("data")[0];
            let city = $(".store-city").select2("data")[0];

            console.log('省市信息:', { province: province?.text, city: city?.text });
            if (_this.edit == false) {
                if (city != undefined) {
                    $(".store-area-location").text(province.text + ' -- ' + city.text);
                    if (province.id == 2 || province.id == 3 || province.id == 4 || province.id == 5) {
                        _this.initMapByCity(province.text);
                        $(".store-detail-addr").val(_this.addressDetail);
                    } else {
                        _this.initMapByCity(city.text);
                        $(".store-detail-addr").val(_this.addressDetail);
                    }
                } else {
                    // 没有选择城市，使用当前位置或默认位置
                    if (_this.current == false) {
                        _this.currentPosition();
                    } else {
                        // 检查是否有有效坐标
                        let lat = parseFloat(_this.latitude);
                        let lng = parseFloat(_this.longitude);
                        if (_this.longitude && _this.latitude && lat !== 0 && lng !== 0 && !isNaN(lat) && !isNaN(lng)) {
                            _this.setMarker(_this.longitude, _this.latitude);
                            _this.getMarkerOption();
                        } else {
                            // 没有坐标或坐标无效，重新定位
                            console.warn('⚠️ 经纬度无效，使用当前位置');
                            _this.currentPosition();
                        }
                    }
                }
            } else {
                if (city != undefined) {
                    $(".store-area-location").text(province.text + ' -- ' + city.text);
                    if (_this.change != city.id) {
                        if (province.id == 2 || province.id == 3 || province.id == 4 || province.id == 5) {
                            _this.initMapByCity(province.text);
                            $(".store-detail-addr").val(null);
                        } else {
                            _this.initMapByCity(city.text);
                            $(".store-detail-addr").val(null);
                        }
                    } else {
                        // 城市未改变，检查是否有有效坐标
                        let lat = parseFloat(_this.latitude);
                        let lng = parseFloat(_this.longitude);
                        if (_this.longitude && _this.latitude && lat !== 0 && lng !== 0 && !isNaN(lat) && !isNaN(lng)) {
                            _this.initMap();
                            $(".store-detail-addr").val(_this.addressDetail);
                        } else {
                            // 没有坐标或坐标无效，使用城市定位
                            console.warn('⚠️ 经纬度无效，使用城市重新定位');
                            if (province.id == 2 || province.id == 3 || province.id == 4 || province.id == 5) {
                                _this.initMapByCity(province.text);
                            } else {
                                _this.initMapByCity(city.text);
                            }
                            $(".store-detail-addr").val(null);
                        }
                    }
                }
            }
            $('.store-detail-addr').bind('input', function () {
                // 清除之前的定时器
                if (_this.searchTimer) {
                    clearTimeout(_this.searchTimer);
                }

                // 设置防抖，延迟500毫秒后执行搜索
                let inputValue = $(this).val();
                if (inputValue != '') {
                    _this.searchTimer = setTimeout(function () {
                        // 获取当前选择的省市信息
                        let province = $(".store-province").select2("data")[0];
                        let city = $(".store-city").select2("data")[0];

                        // 拼接完整地址：省 + 市 + 详细地址
                        let fullAddress = inputValue;
                        if (province && province.text) {
                            fullAddress = province.text + fullAddress;
                        }
                        if (city && city.text) {
                            // 如果省份不是直辖市，则加上城市
                            if (province.id != 2 && province.id != 3 && province.id != 4 && province.id != 5) {
                                fullAddress = province.text + city.text + inputValue;
                            } else {
                                fullAddress = province.text + inputValue;
                            }
                        }

                        console.log('🔍 搜索地址:', fullAddress, '(省市:', province?.text, city?.text, '详细:', inputValue, ')');
                        _this.searchByStationName(fullAddress);
                    }, 500);
                }
            });

        },
        //地图返回
        mapReturn: function () {
            let _this = this;

            // 销毁地图实例，释放资源
            if (_this.map) {
                console.log('🗑️ 销毁地图实例');
                _this.map.destroy();
                _this.map = null;
            }

            // 清除标记图层
            if (_this.markerLayer) {
                _this.markerLayer.setMap(null);
                _this.markerLayer = null;
            }

            // 解绑输入事件，避免重复绑定
            $('.store-detail-addr').unbind('input');

            _this.isMap = false;
            _this.add = true;
        },
        //初始化地图（使用已有经纬度）
        initMap: function () {
            let _this = this;

            console.log('🗺️ initMap - 使用已有坐标:', _this.latitude, _this.longitude);

            // 先销毁旧的地图实例（如果存在）
            if (_this.map) {
                console.log('🗑️ 销毁旧地图实例');
                try {
                    _this.map.destroy();
                } catch (e) {
                    console.warn('销毁地图时出错:', e);
                }
                _this.map = null;
            }

            // 验证坐标是否有效（包括检查0值）
            let lat = parseFloat(_this.latitude);
            let lng = parseFloat(_this.longitude);
            if (!_this.latitude || !_this.longitude || lat === 0 || lng === 0 || isNaN(lat) || isNaN(lng)) {
                console.warn('⚠️ 经纬度无效或为空，使用默认位置');
                _this.latitude = 24.48923061;  // 默认厦门
                _this.longitude = 118.10388605;
            }

            // 延迟一小段时间，确保容器完全渲染
            setTimeout(() => {
                try {
                    let center = new TMap.LatLng(_this.latitude, _this.longitude);
                    console.log('✅ 创建中心点:', center);

                    _this.map = new TMap.Map("store-map", {
                        center: center,
                        zoom: 14,
                        viewMode: '2D'
                    });
                    console.log('✅ 地图实例创建成功');

                    _this.setMarker(_this.longitude, _this.latitude);
                } catch (error) {
                    console.error('❌ 创建地图失败:', error);
                }
            }, 100); // 延迟100毫秒
        },
        //根据城市名初始化地图
        initMapByCity: function (city) {
            let _this = this;

            console.log('🗺️ initMapByCity - 按城市初始化:', city);

            // 先销毁旧的地图实例（如果存在）
            if (_this.map) {
                console.log('🗑️ 销毁旧地图实例');
                try {
                    _this.map.destroy();
                } catch (e) {
                    console.warn('销毁地图时出错:', e);
                }
                _this.map = null;
            }

            // 延迟一小段时间，确保容器完全渲染
            setTimeout(() => {
                try {
                    // 先创建地图（默认中心点北京）
                    _this.map = new TMap.Map("store-map", {
                        center: new TMap.LatLng(39.908802, 116.397502),
                        zoom: 12,
                        viewMode: '2D'
                    });
                    console.log('✅ 地图实例创建成功');

                    // 然后搜索城市并定位
                    console.log('🔍 开始搜索城市:', city);
                    _this.searchByStationName(city);
                } catch (error) {
                    console.error('❌ 创建地图失败:', error);
                }
            }, 100); // 延迟100毫秒
        },
        //设置地图标注
        setMarker: function (lng, lat) {
            let _this = this;

            // 验证坐标是否有效
            if (!lng || !lat || isNaN(lng) || isNaN(lat)) {
                console.error('无效的坐标值:', lng, lat);
                return;
            }

            // 如果已有标记图层，先清除
            if (_this.markerLayer) {
                _this.markerLayer.setMap(null);
            }

            // 创建可拖拽的标记图层
            _this.markerLayer = new TMap.MultiMarker({
                map: _this.map,
                styles: {
                    'marker': new TMap.MarkerStyle({
                        width: 25,
                        height: 35,
                        anchor: { x: 12, y: 35 }
                    })
                },
                geometries: [{
                    id: 'store-marker',
                    position: new TMap.LatLng(lat, lng),
                    styleId: 'marker',
                    properties: {
                        draggable: true
                    }
                }]
            });

            // 监听标记拖拽结束事件
            _this.markerLayer.on('drag_end', function (evt) {
                let position = evt.geometry.position;
                _this.latitude = position.getLat();
                _this.longitude = position.getLng();
                _this.getMarkerOption();
            });

            // 地图居中
            _this.map.setCenter(new TMap.LatLng(lat, lng));
        },
        // 根据关键字获取经纬度
        searchByStationName: function (keyword) {
            let _this = this;

            console.log('🔍 搜索关键字:', keyword);

            // 使用地理编码服务（地址 → 坐标）
            if (!_this.geocoder) {
                _this.geocoder = new TMap.service.Geocoder();
            }

            // 获取当前选择的城市作为搜索范围限定
            let city = $(".store-city").select2("data")[0];
            let searchOptions = {
                address: keyword
            };

            // 如果有选择城市，添加 region 参数来限定搜索范围，提高搜索准确度
            if (city && city.text) {
                searchOptions.region = city.text;
                console.log('🎯 限定搜索范围:', city.text);
            }

            _this.geocoder.getLocation(searchOptions).then(function (result) {
                console.log('搜索结果:', result);

                if (result && result.result && result.result.location) {
                    let location = result.result.location;

                    console.log('✅ 找到坐标:', location);

                    _this.latitude = location.lat;
                    _this.longitude = location.lng;
                    _this.setMarker(location.lng, location.lat);

                    // 地图居中
                    _this.map.setCenter(new TMap.LatLng(location.lat, location.lng));

                    // 不再自动更新省市显示，因为省市由用户通过下拉框选择
                    // 如果需要，可以验证返回的地址是否与选择的省市一致
                    if (result.result.address_components) {
                        let ac = result.result.address_components;
                        console.log('📍 地址信息:', ac.province, ac.city, ac.district, ac.street);
                    }
                } else {
                    console.warn('⚠️ 未找到搜索结果:', keyword);
                    layer.msg('未找到该地址，请检查输入是否正确');
                }
            }).catch(function (error) {
                console.error('❌ 搜索失败:', error);
                layer.msg('地址搜索失败，请重试');
            });
        },
        // 获取标注的位置信息（拖拽后调用）
        getMarkerOption: function () {
            let _this = this;

            // 验证坐标
            if (!_this.latitude || !_this.longitude) {
                console.error('经纬度为空，无法获取位置信息');
                return;
            }

            // 调用逆地理编码
            _this.reverseGeocoder(_this.latitude, _this.longitude);

            // 地图居中
            _this.map.setCenter(new TMap.LatLng(_this.latitude, _this.longitude));
        },
        // 逆地理编码（坐标转地址）
        reverseGeocoder: function (lat, lng) {
            let _this = this;

            // 验证坐标
            if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
                console.error('无效的坐标，无法进行逆地理编码:', lat, lng);
                return;
            }

            if (!_this.geocoder) {
                _this.geocoder = new TMap.service.Geocoder();
            }

            _this.geocoder.getAddress({
                location: new TMap.LatLng(lat, lng)
            }).then(function (result) {
                let addressComponent = result.result.address_component;

                console.log('📍 逆地理编码结果:', addressComponent);

                // 拼接详细地址（不包含省市，只包含区/街道/门牌号）
                let detailAddress = addressComponent.district +
                    addressComponent.street +
                    addressComponent.street_number;

                // 更新详细地址输入框（只显示详细地址部分）
                $(".store-detail-addr").val(detailAddress);
                _this.addressDetail = detailAddress;

                // 省市信息显示在地图区域位置提示中
                $('.store-area-location').text(
                    addressComponent.province + " -- " + addressComponent.city
                );

                console.log('✅ 地址已更新 - 详细地址:', detailAddress, '省市:', addressComponent.province, addressComponent.city);
            }).catch(function (error) {
                console.error('❌ 逆地理编码失败:', error);
                layer.msg('获取地址信息失败，请重试');
            });
        },
        // 如果没有选择城市则定位当前位置
        currentPosition: function () {
            let _this = this;
            _this.current = true;

            // 延迟一小段时间，确保容器完全渲染
            setTimeout(() => {
                // 先创建地图（默认厦门坐标）
                let defaultCenter = new TMap.LatLng(24.48923061, 118.10388605);
                _this.map = new TMap.Map("store-map", {
                    center: defaultCenter,
                    zoom: 12,
                    viewMode: '2D'
                });
                console.log('✅ 地图创建成功，开始定位...');

                // 使用浏览器原生定位
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            let lat = position.coords.latitude;
                            let lng = position.coords.longitude;

                            console.log('浏览器定位成功:', lat, lng);
                            _this.latitude = lat;
                            _this.longitude = lng;
                            _this.setMarker(lng, lat);
                            _this.getMarkerOption();
                        },
                        function (error) {
                            console.error('浏览器定位失败:', error.message);
                            // 失败则使用腾讯地图IP定位
                            _this.ipLocation();
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0
                        }
                    );
                } else {
                    console.warn('浏览器不支持定位，使用IP定位');
                    // 浏览器不支持，使用IP定位
                    _this.ipLocation();
                }
            }, 100); // 延迟100毫秒
        },
        // IP定位（备用方案）
        ipLocation: function () {
            let _this = this;

            let ipLocation = new TMap.service.IPLocation();
            ipLocation.locate().then(function (result) {
                let location = result.result.location;
                console.log('IP定位成功:', location.lat, location.lng);
                _this.latitude = location.lat;
                _this.longitude = location.lng;
                _this.setMarker(location.lng, location.lat);
                _this.getMarkerOption();
            }).catch(function (error) {
                console.error('IP定位失败:', error);
                layer.msg('定位失败，请手动搜索位置');
            });
        },
        //地图保存
        saveMap: function () {
            let _this = this;
            _this.isMap = false;
            _this.add = true;
            _this.addressDetail = $(".store-detail-addr").val();
            let area = $(".store-area-location").text();
            // console.log(area);
            let areas = area.split("--");
            _this.store_province = areas[0];
            _this.store_city = areas[1];
            // console.log( _this.store_province);
            _this.store_provinceId = _this.getIdByText(areas[0], _this.mapDetail);
            if (_this.store_provinceId == 2 || _this.store_provinceId == 3 || _this.store_provinceId == 4 || _this.store_provinceId == 5) {
                _this.store_cityId = _this.store_provinceId;
            } else {
                _this.store_cityId = _this.getIdByText(areas[1], _this.mapDetail[_this.store_provinceId - 2].child);
            }
            // console.log( _this.store_provinceId );
            // console.log( _this.store_cityId );
            $(".store-province").val(_this.store_provinceId).trigger("change");
            let res = $(".store-province").select2("data")[0];
            let id = res.id;
            _this.getCity(id);
            $(".store-city").val(_this.store_cityId).trigger("change");
        },
        // 根据省市的text,查询其id
        getIdByText: function (key, array) {
            //              console.log(array);
            if (key != "" && key != undefined) {
                let id = 0;
                $.each(array, function (i, item) {
                    if (item.value == key || (item.value != "" && key.indexOf(item.value.substr(0, 2)) > -1)) {
                        id = item.id;
                        return false;
                    }
                });
                return id;
            } else {
                return "";
            }
        },
        //校验
        check: function () {
            let _this = this;
            if (_this.storeImg == null) {
                layer.msg("请上传门店印象！", {
                    time: 1200
                });
                return false;
            }
            if (_this.storeName == null) {
                layer.msg("请填写门店名称！", {
                    time: 1200
                });
                $(".store-name").focus();
                return false;
            }
            // let myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
            if (_this.telephone == null) {
                layer.msg('请输入手机号码！', {
                    time: 1200
                });
                $(".store-phone").focus();
                return false;
            }
            // else if(_this.telephone.length != 11) {
            //     layer.msg('请输入有效的手机号码！',{
            //         time: 1200
            //     });
            //     $(".store-phone").focus();
            //     return false;
            // }else if(!myreg.test(_this.telephone)){
            //     layer.msg('请输入有效的手机号码！',{
            //         time: 1200
            //     });
            //     $(".store-phone").focus();
            //     return false;
            // }
            if ($(".store-province").val() == "1") {
                layer.msg('请选择省市！', {
                    time: 1200
                });
                return false;
            }
            if (_this.addressDetail == null) {
                layer.msg("请填写详细地址！", {
                    time: 1200
                });
                $(".address-detail").focus();
                return false;
            }
            if (_this.businessTime == null) {
                layer.msg("请选择营业时间！", {
                    time: 1200
                });
                $(".store-time").focus();
                return false;
            }
            return true;
        },

        // 点击上传xls文件
        addXlsFun: function () {
            this.$refs.xlsFile.click();
        },
        // 上传
        uploadXls: function (e) {
            let _this = this;

            let formData = new FormData();
            formData.append("xlsFile", $("#xlsFile")[0].files[0]);
            // 清除file
            let obj = document.getElementById('xlsFile');
            obj.value = '';

            $.ajax({
                type: "post",
                dataType: "json",
                processData: false,
                contentType: false,
                url: Vue.ctUrl + "Room/import",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: formData,
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('导入成功');
                        $(_this.$refs.storelist).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 获取包厢配置数据
        getRoomConfig: function (shopId) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shopId
                    }
                },
                "comment": []
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Room/getRoomConfig",
                data: {
                    json: datas2
                },
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.room_type = data.response.result.room_type;
                        _this.room_area = data.response.result.room_area;
                        _this.room_scene = data.response.result.room_scene;
                        _this.$nextTick(function () {
                            _this.initRoomSelects();
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },
        // 初始化包厢列表的下拉框
        initRoomSelects: function () {
            let _this = this;

            // 初始化包厢区域下拉框
            let areaData = [{ id: "", text: "" }];
            _this.room_area.forEach(function (item) {
                areaData.push({ id: item.id, text: item.name });
            });
            $(_this.$refs.roomArea).select2({
                data: areaData,
                allowClear: true,
                minimumResultsForSearch: -1,
                language: "zh-CN"
            });

            // 初始化包厢类型下拉框
            let typeData = [{ id: "", text: "" }];
            _this.room_type.forEach(function (item) {
                typeData.push({ id: item.id, text: item.name });
            });
            $(_this.$refs.roomType).select2({
                data: typeData,
                allowClear: true,
                minimumResultsForSearch: -1,
                language: "zh-CN"
            });

            // 初始化运营场景下拉框
            let sceneData = [{ id: "", text: "" }];
            _this.room_scene.forEach(function (item) {
                sceneData.push({ id: item.id, text: item.name });
            });
            $(_this.$refs.roomScene).select2({
                data: sceneData,
                allowClear: true,
                minimumResultsForSearch: -1,
                language: "zh-CN"
            });
        },
        // 返回门店列表
        returnToStoreList: function () {
            this.roomList = false;
            this.currentStoreName = null;
            this.currentStoreId = null;
            this.roomNumber = null;
            this.roomListData = []; // 清空查询结果
            // 清空下拉框数据
            this.room_type = [];
            this.room_area = [];
            this.room_scene = [];
            // 重置分页数据
            this.roomCurrentPage = 1;
            this.roomPageSize = 10;
            this.roomTotal = 0;
        },
        // 查询包厢列表
        queryRoomList: function () {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.currentStoreId,
                        "name": _this.roomNumber || "",
                        "room_area": $(_this.$refs.roomArea).val() || "",
                        "room_type": $(_this.$refs.roomType).val() || "",
                        "operational_scene": $(_this.$refs.roomScene).val() || "",
                        "page": _this.roomCurrentPage,
                        "page_size": _this.roomPageSize
                    }
                },
                "comment": []
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Room/getList",
                data: {
                    json: datas2
                },
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    console.log('查询', data);

                    if (data.response.result_code == "true") {
                        // 适配新的数据结构
                        _this.roomListData = data.response.result.data || [];
                        _this.roomTotal = parseInt(data.response.result.count) || 0;
                        layer.msg("查询成功");
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },
        // 导出包厢列表
        exportRoomList: function () {
            let _this = this;
            window.location.href =
                Vue.ctUrl +
                "Room/export" +
                "?shop_id=" +
                _this.currentStoreId +
                "&name=" +
                _this.roomNumber +
                "&room_area=" +
                $(_this.$refs.roomArea).val() +
                "&room_type=" +
                $(_this.$refs.roomType).val() +
                "&operational_scene=" +
                $(_this.$refs.roomScene).val();
            layer.msg("导出成功！");
        },

        // 自助开房二维码
        qrCode: function (row) {
            let _this = this;
            let qrCodeUrl = row.qrcode_url;
            let url = row.url;
            let roomNumber = row.name;

            layer.open({
                type: 1,
                content: '<div style="text-align: center; padding: 20px; background-color: #f5f5f5;">' +
                    '<h3 style="margin: 0 0 15px 0; color: #333; font-size: 18px;">自助开房二维码</h3>' +
                    '<div style="font-size: 20px; font-weight: bold; color: #333; margin-bottom: 20px;">' + roomNumber + '</div>' +
                    '<div style="margin-bottom: 20px;"><img src="' + qrCodeUrl + '" style="max-width: 200px; max-height: 200px;" /></div>' +
                    '<button id="copyUrlBtn" style="padding: 8px 16px; border: 1px solid #ddd; border-radius: 4px; background: white; color: #333; cursor: pointer;">复制二维码链接</button>' +
                    '</div>',
                area: ['350px', '400px'],
                title: false,
                shadeClose: true,
                success: function (layero, index) {
                    // 绑定复制按钮事件
                    document.getElementById('copyUrlBtn').onclick = function () {
                        _this.copyToClipboard(url);
                    };
                }
            });
        },

        // 复制到剪贴板
        copyToClipboard: function (text) {
            let _this = this;
            if (navigator.clipboard && window.isSecureContext) {
                // 使用现代浏览器的 Clipboard API
                navigator.clipboard.writeText(text).then(function () {
                    layer.msg('链接已复制到剪贴板');
                }).catch(function (err) {
                    console.error('复制失败:', err);
                    _this.fallbackCopyToClipboard(text);
                });
            } else {
                // 降级方案
                _this.fallbackCopyToClipboard(text);
            }
        },

        // 降级复制方案
        fallbackCopyToClipboard: function (text) {
            let _this = this;
            let textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                document.execCommand('copy');
                layer.msg('链接已复制到剪贴板');
            } catch (err) {
                console.error('复制失败:', err);
                layer.msg('复制失败，请手动复制');
            }

            document.body.removeChild(textArea);
        },

        // 分页事件处理
        // 每页显示数量变化
        handleRoomSizeChange: function (val) {
            let _this = this;
            _this.roomPageSize = val;
            _this.roomCurrentPage = 1; // 重置到第一页
            _this.queryRoomList();
        },

        // 当前页码变化
        handleRoomCurrentChange: function (val) {
            let _this = this;
            _this.roomCurrentPage = val;
            _this.queryRoomList();
        },

        // 处理查询按钮点击，重置到第一页
        handleQueryRoomList: function () {
            let _this = this;
            _this.roomCurrentPage = 1; // 重置到第一页
            _this.queryRoomList();
        },
    }
}
</script>

<style lang="less">
.tab-content {
    position: relative;
    /*z-index: 0;*/
}

.store {
    .row {
        a {
            text-decoration: none;
            color: #fff;
        }

        #xlsFile {
            display: none;
        }
    }

    .addstore {
        /*width: 100%;*/
        /*background-color: rgb( 255 , 130 , 0 );*/
        /*color: #ffffff;*/
        height: 40px;
        /*font-size: 14px;*/
        /*border-radius: 0;*/
        /*border:1px solid rgb( 255 , 130 , 0 );*/
    }

    /*.addstore:hover {*/
    /*box-shadow: inset 0 0 100px rgba(0,0,0,.2);*/
    /*}*/
    .filter {
        margin: 40px 20px 40px 0;

        .storename {
            font-size: 14px;
            color: #5e5e5e;
            padding-left: 0;
            text-align: right;
            height: 32px;
            line-height: 32px;
        }

        .select2-selection--single {
            height: 32px;
            line-height: 32px;
            border-radius: 0 !important;
            outline: none;
            border: 1px solid #d5d5d5 !important;

            .select2-selection__rendered {
                line-height: 32px;
            }
        }

        .filterbtn {
            /*width: 100%;*/
            /*background-color: rgb( 255 , 130 , 0 );*/
            /*color: #ffffff;*/
            /*border-radius: 0;*/
            height: 32px;
            /*font-size: 14px;*/
            /*border:1px solid rgb( 255 , 130 , 0 );*/
        }
    }
}

.select2-search__field {
    border: 1px solid #d5d5d5 !important;
}

.select2-dropdown {
    border-radius: 0 !important;
    border: 1px solid #d5d5d5 !important;
}

.addStore {
    z-index: 1;

    .addTitle {
        font-size: 18px;
        color: #323232;
        margin: 0;
    }

    .storeContent {
        margin: 30px 33px 60px 0;

        .impression {
            margin: 0 0 36px 10px;

            .impressiontitle {
                font-size: 14px;
                color: #5e5e5e;
                text-align: right;
                width: 100px;
            }

            .upload {
                width: 500px;
                height: 240px;
                margin-left: 15px;
                vertical-align: top;
                cursor: pointer;
                background: url("../../assets/images/upload_store.png") center no-repeat;
            }
        }

        .line {
            height: 32px;
            line-height: 32px;
            margin-bottom: 36px;
            font-size: 14px;

            .formname {
                color: #5e5e5e;
                line-height: 32px;
                text-align: right;
                width: 100px;
            }

            .select2-container {
                box-sizing: border-box;
                display: inline-block;
                margin: 0;
                position: relative;
                vertical-align: middle;
                width: 100% !important;

                .select2-selection--single {
                    height: 32px;
                    line-height: 32px;
                    border-radius: 0 !important;
                    outline: none;
                    border: 1px solid #d5d5d5 !important;

                    .select2-selection__rendered {
                        line-height: 32px;
                    }

                    .select2-selection__arrow {
                        height: 32px;
                        line-height: 32px;
                    }
                }
            }
        }
    }

    .addbtn {
        height: 34px;
        font-size: 14px;
    }

    .sure {
        margin-left: 50px;
    }
}

.shade {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
}

.popup {
    z-index: 3;
    max-height: 430px;
    width: 460px;
    background-color: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -230px;
    margin-top: -215px;
    padding: 10px 20px;

    .popclose {
        position: absolute;
        height: 10px;
        width: 10px;
        top: 15px;
        right: 20px;
        background: url("../../assets/images/icon-close-tab10x10.png") center no-repeat;
        cursor: pointer;
    }

    .poptitle {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #d5d5d5;
        font-size: 16px;
        color: #333333;
        width: 100%;
        text-align: center;
    }

    .timeContent {
        padding: 0 45px;

        input {
            margin: 4px 8px 0 0;
        }

        .starttime {
            font-size: 15px;
            color: #333333;
            margin: 20px 0 25px 0;
        }

        .time {
            display: inline-block;
            height: 45px;
            width: 150px;
        }

        .select2-selection--single {
            height: 45px;
            line-height: 45px;
            border-radius: 0 !important;
            outline: none;
            border: 1px solid #d5d5d5 !important;

            .select2-selection__rendered {
                line-height: 45px;
                font-size: 17px;
                color: #9d9d9d;
            }

            .select2-selection__arrow {
                height: 45px;
                line-height: 45px;
            }
        }

        .colon {
            width: 18px;
            text-align: center;
            line-height: 45px;
            font-size: 20px;
            color: #9d9d9d;
        }

        .popbottom {
            margin-top: 40px;
            margin-bottom: 25px;

            .popbtn {
                height: 44px;
            }
        }

        .radiocontent {
            width: 100%;
            padding: 15px 0 0 85px;

            .radiolist {
                height: 30px;
                line-height: 30px;
                font-size: 15px;
                color: #333333;

                input {
                    margin: 9px 0 0 -25px;
                }
            }
        }
    }
}

.store-location {
    .detalilabel {
        font-size: 14px;
        color: #5e5e5e;
        padding-left: 0;
        text-align: right;
        height: 32px;
        line-height: 32px;
        width: 85px;
    }

    .detailspan {
        font-size: 14px;
        color: #5e5e5e;
        padding-left: 0;
        text-align: left;
        height: 32px;
        line-height: 32px;
    }

    .store-map {
        overflow: hidden;
        position: relative;
        z-index: 0;
        background-color: #ffffff;
        color: rgb(0, 0, 0);
        text-align: left;
        height: 520px;
        width: 90%;
        margin-left: 25px;
    }

    .mapbtn {
        height: 34px;
        font-size: 14px;
    }

    /* 隐藏腾讯地图的版权信息和控件 */
    .tmap-copyright,
    .tmap-logo {
        display: none !important;
    }
}

// 包厢列表样式
.room-list-container {
    padding: 20px;

    .room-list-header {
        margin-bottom: 30px;

        .room-list-title {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin: 0 0 10px 0;
        }

        .store-info {
            font-size: 16px;
            color: #666;
        }
    }

    .room-filter-section {
        background: #f8f9fa;
        padding: 20px;
        border-radius: 5px;
        margin-bottom: 20px;

        .filter-row {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 20px;

            .filter-item {
                display: flex;
                align-items: center;
                min-width: 200px;

                .filter-label {
                    font-size: 14px;
                    color: #333;
                    margin-right: 10px;
                    white-space: nowrap;
                }

                .form-control {
                    height: 32px;
                    border-radius: 0;
                    border: 1px solid #d5d5d5;
                }

                .room-number-input {
                    width: 150px;
                }

                .room-area-select,
                .room-type-select,
                .room-scene-select {
                    width: 120px;
                }
            }

            .filter-actions {
                display: flex;
                gap: 10px;

                .btn {
                    height: 32px;
                    padding: 0 15px;
                    font-size: 14px;
                }

                .query-btn,
                .export-btn {
                    background-color: #007bff;
                    border-color: #007bff;
                    color: white;
                }
            }
        }
    }

    .room-table-section {
        margin-bottom: 20px;

        .room-table {
            th {
                background-color: #f8f9fa;
                font-weight: bold;
                text-align: center;
                padding: 12px 8px;
            }

            td {
                text-align: center;
                padding: 10px 8px;
            }
        }
    }

    .room-actions {
        text-align: right;
        margin-bottom: 20px;

        .qr-code-link {
            color: #007bff;
            text-decoration: none;
            font-size: 14px;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .room-footer {
        text-align: center;
        padding-top: 20px;
        border-top: 1px solid #eee;

        .return-btn {
            height: 34px;
            padding: 0 20px;
            font-size: 14px;
        }
    }

    // 分页组件样式
    .room-pagination {
        margin-top: 20px;
        text-align: center;

        .el-pagination {
            display: inline-block;
        }
    }
}
</style>
